import ContrastBlackLight from '@assets/icons/contrast-black-light.svg'
import { Icon } from './Icon'

export const ContrastBlackLightIcon = Icon(ContrastBlackLight)
